import { useNavigate } from 'react-router-dom';

import {
  EstadoOLTOptions,
  generacionTroncalesSchema,
  gridSizeMdLg12,
  gridSizeMdLg2,
  gridSizeMdLg3,
  gridSizeMdLg5,
  gridSizeMdLg6,
  hasPermission,
  oltFormSchema,
  ROUTER_PATHS,
  useCheckPermissionsArray,
  // useLoaders,
  useMapComponent,
} from '@/shared';
import {
  CreateOLTParams,
  getNodos,
  useCreateOLT,
  useFetchGetBras,
  useGenerarMangasTroncalesDesdeOLT,
  // useFetchAllNodes,
  useUpdateOLT,
} from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  // CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomDynamicSearch,
  CustomNumberTextField,
  CustomPasswordTextField,
  // CustomTextArea,
  CustomTextField,
  SampleTable,
  SingleFormBoxScene,
  SwitchComponenteForm,
  TabTextLabel,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
  Nodo,
  // City,
  // Nodo,
  OLT,
  // Pais,
  // Province,
  // Sector,
  // Zone,
} from '@/shared/interfaces';
import { useUiConfirmModalStore, useUiStore } from '@/store/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { SAVE_OLT_PERMISSIONS } from '../../constants';
// import { useLocalidad } from '@/shared/hooks/useLocalidad';
import CustomCoordendasForm from '@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm';
import { IBras } from '@/shared/interfaces/erp/configuracion-red/bras/bras.interface';
import { Button, Grid, Typography } from '@mui/material';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import { MRT_ColumnDef } from 'material-react-table';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { useAuthStore } from '@/store/auth';
import { PermissionsEnum } from '@/auth/interfaces';


export interface SaveOLTComponentProps {
  title: string;
  olt?: OLT;
}

type SaveFormData = CreateOLTParams & {
  latitud: string;
  longitud: string;
  migrado?: boolean;
};

interface IGeneracionMangasOlt {
  rango_inicio_manga: string;
  rango_fin_manga: string;
  numero_mangas?: number;
}

const SaveOLTComponent: React.FC<SaveOLTComponentProps> = ({ title, olt }) => {
  useCheckPermissionsArray(SAVE_OLT_PERMISSIONS);

  const returnUrlOLTsPage = ROUTER_PATHS.configuracionRED.oltNav;
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(oltFormSchema as any),
    defaultValues: {
      estado:true,
      latitud: "0",
      longitud: "0",
      coordenadas: olt?.coordenadas ?? '0,0'
    }
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = form;

  //form generacion troncales
  const formGenTroncales = useForm<{
    rango_inicio_manga: string;
    rango_fin_manga: string;
  }>({
    resolver: yupResolver(generacionTroncalesSchema as any),
  });


  ///* store
  const setAlert = useUiStore(s => s.setAlert);

  // const {
  //   dataPais,
  //   isLoadingPais,
  //   dataProvincia,
  //   isLoadingProvincia,
  //   dataCiudad,
  //   isLoadingCiudad,
  //   dataZona,
  //   isLoadingZona,
  //   dataSector,
  //   isLoadingSector,
  //   handleReset
  // } = useLocalidad({
  //   form: form as any,
  //   cobertura: true
  // })

  // const watchedZona = form.watch('zona');
  const watchedCiudad = form.watch('ciudad');
  //const watchedCoordenadas = form.watch('coordenadas');

  // mapa con naps 
  const {
    // Map: MapaComponente,
    // latLng,
    setLatLng,
    // napsByCity,
    setCurrentCoordenadas,
    // isLoadingNapsByCity,
    // currentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: watchedCiudad,
    distanciaNapKey: 'distancia_aproximada',
    coordenadasCliente: olt?.nodo_data?.coordenadas ?? '',
    enabledFetchNaps: false
  });

  const {
    data: allBras,
    isLoading: isLoadingBras,
    isRefetching: isRefetchingBras,
  } = useFetchGetBras({
    enabled: true,
    params: {
      page_size: 1000,
    },
  })


  // const {
  //   data: nodosByZonePaging,
  //   isLoading: isLoadingNodos,
  //   isRefetching: isRefetchingNodos,
  // } = useFetchAllNodes({
  //   enabled: !!watchedZona, ///* zona
  //   params: {
  //     page_size: 1000,
  //     zona: watchedZona,
  //   },
  // });

  ///* mutations
  const createOLT = useCreateOLT({
    navigate,
    returnUrl: returnUrlOLTsPage,
  });
  const updateOLT = useUpdateOLT({
    navigate,
    returnUrl: returnUrlOLTsPage,
  });

  const generarMangas = useGenerarMangasTroncalesDesdeOLT({})

  const GenerarMangasTroncales = (data: any) => {
    let numerosInicioRango = parseFloat(data?.rango_inicio_manga?.split(' ')[1]);
    let numerosFinRango = parseFloat(data?.rango_fin_manga?.split(' ')[1]);
    console.log(numerosInicioRango, numerosFinRango);
    if(numerosInicioRango >= numerosFinRango){
      return toast.error('El rango de inicio debe ser menor al rango de fin');
    }
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro que desea generar las mangas troncales? (esta acción es irreversible).",
      title: "Generación de Mangas Troncales Automática",
      onConfirm: async () => {
        let observaciones = olt?.observaciones || {};
        observaciones["detalle_generacion_mangas"] = olt?.observaciones?.detalle_generacion_mangas || []
        observaciones["detalle_generacion_mangas"].push({
          rango_inicio_manga: data?.rango_inicio_manga,
          rango_fin_manga: data?.rango_fin_manga,
          creado_por: user?.username,
          fecha_creacion: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        })
        setConfirmDialogIsOpen(false);

        await generarMangas.mutateAsync({
          id: olt?.id_olt!!,
          data: {
            generar_mangas: true,
            rango_inicio_manga: data?.rango_inicio_manga,
            rango_fin_manga: data?.rango_fin_manga,
            observaciones: observaciones,
          },
        });
        formGenTroncales.reset();
      },
      onClose() {
        setConfirmDialogIsOpen(false);
      },
    });
  };


  useEffect(() => {

    if (!olt) return;

    reset(olt)

    const coordenada = olt.coordenadas;

    if (!coordenada) return;

    setLatLng({
      lat: +coordenada.split(',')[0],
      lng: +coordenada.split(',')[1],
    })

    setCurrentCoordenadas(coordenada);

    return () => {

    }
  }, [olt])


  ///* handlers
  const onSave = async (data: SaveFormData) => {

    ///* update
    if (olt) {
      await updateOLT.mutateAsync({
        id: olt.id_olt!,
        data: {
          ...data,
        },
      });
      return;
    }

    ///* create
    await createOLT.mutateAsync(data);
  };
  const user = useAuthStore(s=>s.user)

  const columnsGeneracionMangasDesdeOlt = useMemo<MRT_ColumnDef<IGeneracionMangasOlt>[]>(
    () => [
      {
        accessorKey: "rango_inicio_manga",
        header: "Rango inicio manga",
        size: 200,
      },
      {
        accessorKey: "rango_fin_manga",
        header: "Rango fin manga",
        size: 200,
      },
      {
        accessorKey: "creado_por",
        header: "Creado por",
        size: 100,
      },
      {
        accessorKey: "fecha_creacion",
        header: "Fecha de creación",
        size: 200,
        Cell: ({ cell }) => {
          return cell.getValue() ? dayjs(cell.getValue() as string).format('DD/MM/YYYY HH:mm') : '';
        },
      }
    ],
    []
  );


  // useLoaders(
  //   isLoadingNapsByCity
  // )

  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlOLTsPage)}
      onSave={handleSubmit(onSave, (errors) => {
        setAlert(true, 'Campos sin llenar', AlertSeverityEnum.error)
        console.log('errors', errors);
      })}
    >

      {
        olt 
        && (
          hasPermission(PermissionsEnum.administration_manage_system)
          || hasPermission(PermissionsEnum.generacion_auto_mangas)
        ) && (<>
          <TabTextLabel text="Generación Automática de Mangas Troncales" />
            <Grid {...gridSizeMdLg12} container item spacing={2}>

              
              <CustomTextField
                label="Rango inicio manga"
                defaultValue=""
                size={gridSizeMdLg6}
                name="rango_inicio_manga"
                control={formGenTroncales.control}
                error={formGenTroncales.formState.errors.rango_inicio_manga}
                helperText={formGenTroncales.formState.errors.rango_inicio_manga?.message}
                required={false}
                
              />
              <CustomTextField
                label="Rango fin manga"
                defaultValue=""
                size={gridSizeMdLg6}
                name="rango_fin_manga"
                control={formGenTroncales.control}
                error={formGenTroncales.formState.errors.rango_fin_manga}
                helperText={formGenTroncales.formState.errors.rango_fin_manga?.message}
                required={false}
              />
              <Grid {...gridSizeMdLg12} container item>
                <Button variant="contained" color="primary"
                  fullWidth
                  onClick={()=>{
                    formGenTroncales.handleSubmit(
                      GenerarMangasTroncales, 
                      (error) => {
                        console.log(error);
                        toast.error('Por favor, complete todos los campos requeridos');
                      }
                    )()
                  }}
                >
                  Generar Mangas Troncales
                </Button>
              </Grid>

            </Grid>
            <Grid {...gridSizeMdLg12} container item>
              <SampleTable
                columns={columnsGeneracionMangasDesdeOlt}
                data={olt?.observaciones?.detalle_generacion_mangas || []}
              />
            </Grid>
        </>)
      }

      {
        (
          !hasPermission(PermissionsEnum.generacion_auto_mangas)
          || hasPermission(PermissionsEnum.administration_manage_system)
        ) && (
          <>
            <Grid {...gridSizeMdLg12} container item>
              <CustomAlertCard
                alertTitle='Información'
                bgColorAlert="SKY"
                alertMessage={form.watch().es_bras ? 'OLT con esquema BRAS' : 'OLT con esquema Router'}
              />
            </Grid>

            <SwitchComponenteForm
              label={"BRAS"}
              size={gridSizeMdLg2}
              control={form.control}
              defaultValue={!!form.getValues()?.es_bras}
              name="es_bras"
              onChangeValue={(_value) => {
                form.setValue('bras', '')
                form.setValue('bras_backup', '')
              }}
            />
            <CustomAutocomplete<IBras>
              label="BRAS Principal"
              name="bras"
              //// options
              options={allBras?.data?.data || []}
              // label & id as fk
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().bras || ''}
              isLoadingData={isLoadingBras || isRefetchingBras}
              //// validation
              control={form.control}
              error={errors.bras}
              helperText={errors.bras?.message}
              required={false}
              size={gridSizeMdLg5}
              disabled={!form.watch().es_bras}
            />
            <CustomAutocomplete<IBras>
              label="BRAS Backup"
              name="bras_backup"
              //// options
              options={allBras?.data?.data || []}
              // label & id as fk
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().bras_backup || ''}
              isLoadingData={isLoadingBras || isRefetchingBras}
              //// validation
              control={form.control}
              error={errors.bras_backup}
              helperText={errors.bras_backup?.message}
              required={false}
              size={gridSizeMdLg5}
              disabled={!form.watch().es_bras}
            />
            <CustomTextField
              label="Nombre"
              name="nombre"
              control={form.control}
              defaultValue={form.getValues().nombre}
              error={errors.nombre}
              helperText={errors.nombre?.message}
              type='none'
            // size={gridSizeMdLg6}
            />


            <CustomDynamicSearch<Nodo>
              size={gridSizeMdLg6}
              label={'Nodo'}
              name="nodo"
              valueKey="nombre"
              actualValueKey="codigo"
              functionToGetData={getNodos}
              defaultValue={ olt?.nodo || form.getValues()?.nodo || ""}
              onChangeRawValue={(rawValue)=>{
                form.setValue("coordenadas",rawValue.coordenadas)
                let s = rawValue.coordenadas.split(",");
                setLatLng({ lat: parseFloat(s[0]), lng: parseFloat(s[1]) });
                setCurrentCoordenadas(rawValue.coordenadas);
              }}
              control={form.control}
              error={form.formState.errors.nodo}
              helperText={form.formState.errors.nodo?.message || "Escriba el nombre del nodo a escoger"}
              required={false}
            />


            <Grid {...gridSizeMdLg12} container item my={1}>
              <Grid {...gridSizeMdLg12} rowSpacing={3} py={2} px={1} container item sx={{borderRadius:1, boxShadow:"2px 2px 10px 5px gray"}}>
                <Grid {...gridSizeMdLg12} container item px={1}>
                  <Typography variant='h5'>DATOS SSH</Typography>
                </Grid>
                <CustomTextField
                  label="Hostname"
                  name="hostname"
                  type="none"
                  control={form.control}
                  defaultValue={form.getValues().hostname}
                  error={errors.hostname}
                  helperText={errors.hostname?.message}
                  size={gridSizeMdLg6}
                  required={false}
                />
                <CustomPasswordTextField
                  label="Password"
                  name="password"
                  errors={errors}
                  form={form}
                  size={gridSizeMdLg6}
                />
                <CustomTextField
                  label="IPv4 OLT"
                  name="ip_pppoe"
                  control={form.control}
                  defaultValue={form.getValues().ip_pppoe}
                  error={errors.ip_pppoe}
                  helperText={errors.ip_pppoe?.message}
                  size={gridSizeMdLg6}
                  type="ipv4"
                />
                <CustomNumberTextField
                  label="Puerto SSH"
                  name="puerto"
                  control={form.control}
                  defaultValue={form.getValues().puerto}
                  error={errors.puerto}
                  helperText={errors.puerto?.message}
                  size={gridSizeMdLg6}
                  required={false}
                />

              </Grid>
            </Grid>





            <Grid {...gridSizeMdLg12} container item my={1}>
              <Grid {...gridSizeMdLg12} rowSpacing={3} py={2} px={1} container item sx={{borderRadius:1, boxShadow:"2px 2px 10px 5px gray"}}>
                <Grid {...gridSizeMdLg12} container item px={1}>
                  <Typography variant='h5'>DATOS SNMP</Typography>
                </Grid>
                <CustomTextField
                  label="Username"
                  name="username_snmp"
                  type="none"
                  control={form.control}
                  defaultValue={form.getValues().username_snmp}
                  error={errors.username_snmp}
                  helperText={errors.username_snmp?.message}
                  size={gridSizeMdLg6}
                  required={false}
                />
                <CustomPasswordTextField
                  label="Password"
                  name="password_snmp"
                  errors={errors}
                  form={form}
                  size={gridSizeMdLg6}
                />
                <CustomTextField
                  label="Comunidad SNMP"
                  name="comunidad_snmp"
                  control={form.control}
                  defaultValue={form.getValues().comunidad_snmp}
                  error={errors.comunidad_snmp}
                  helperText={errors.comunidad_snmp?.message}
                  size={gridSizeMdLg6}
                  type='none'
                />

                <CustomTextField
                  label="Versión SNMP"
                  name="version_snmp"
                  control={form.control}
                  defaultValue={form.getValues().version_snmp}
                  error={errors.version_snmp}
                  helperText={errors.version_snmp?.message}
                  size={gridSizeMdLg6}
                />

                <CustomNumberTextField
                  label="VLAN"
                  name="vlan_pppoe"
                  control={form.control}
                  defaultValue={form.getValues().vlan_pppoe}
                  error={errors.vlan_pppoe}
                  helperText={errors.vlan_pppoe?.message}
                  size={gridSizeMdLg12}
                  required={false}
                  shrink={true}
                />

              </Grid>
            </Grid>

          


            <CustomAutocompleteArrString
            name='estado_olt'
            label='Estado OLT'
            options={EstadoOLTOptions}
            defaultValue={form.getValues()?.estado_olt as string}
            isLoadingData={false}
            error={errors.estado_olt}
            helperText={errors.estado_olt?.message}
            control={control}
            size={gridSizeMdLg6}
            />
            <SwitchComponenteForm
              label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
              size={gridSizeMdLg3}
              control={form.control}
              defaultValue={!!form.getValues()?.estado}
              name="estado"
            />

            <SwitchComponenteForm
              label={`Migrado: ${form.watch()?.migrado ? 'SI' : 'NO'}`}
              size={gridSizeMdLg3}
              control={form.control}
              defaultValue={!!form.getValues()?.migrado}
              name="migrado"
            />


            <TabTextLabel text='Ubicación' mt={5}/>

            {/* ========= Detalles Instalacion ========= */}
            {/* ========== nap ========== */}
            <CustomCoordendasForm
              form={form}
              label="Coordendas"
              name="coordenadas"
              defaultValue={form.watch().coordenadas}
              key={'key_bras_coordenadas'}
              size={gridSizeMdLg12}
              onlyValueLocation={true}
              enableLocationOnChange={false}
              handleDataUbicacion={(watchedCoordenadas) => {

                if (!watchedCoordenadas) return;

                setLatLng({
                  lat: +watchedCoordenadas.split(',')[0],
                  lng: +watchedCoordenadas.split(',')[1],
                })

                setCurrentCoordenadas(watchedCoordenadas);

              }}
            />

            <CustomTextField
              label="Dirección"
              name="direccion"
              control={form.control}
              defaultValue={form.getValues().direccion}
              error={errors.direccion}
              helperText={errors.direccion?.message}
              size={gridSizeMdLg12}
              required={false}
            />
          </>
        )
      }





    </SingleFormBoxScene>
  );
};

export default SaveOLTComponent;
